export default __webpack_public_path__ + "static/media/LETO-extrait-accap-mozart-capitaine.0ca95eb4.mp3";